import { render } from "./overall-settings.vue?vue&type=template&id=31cf7d6b"
import script from "./overall-settings.vue?vue&type=script&lang=js"
export * from "./overall-settings.vue?vue&type=script&lang=js"

import "./overall-settings.vue?vue&type=style&index=0&id=31cf7d6b&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__